import React, { Component } from "react";
import AuctionRequest from "../components/Exchange/AuctionRequest";
import querySearch from "stringquery";

import { getAuctionExchangeRequest } from "../services/ReportService";

export default class AuctionExchangeReceipt extends Component {
	constructor() {
		super();
		this.state = { reportData: null };
	}
	componentDidMount() {
		const query = querySearch(window.location.search);
		getAuctionExchangeRequest(query.tid, query.lang).then((res) => {
			this.setState({ reportData: res.data, urldata: query.v });
			document.title = "Auction_Request_" + res.data.transactionNumber;
		});
	}
	render() {
		return this.state.reportData ? (
			<div style={{ height: "100%" }}>
				<AuctionRequest
					result={this.state.reportData}
					isBankCopy={false}
					copyPrint={this.state.urldata}
				/>
				<AuctionRequest result={this.state.reportData} isBankCopy={true} />
			</div>
		) : (
			<div></div>
		);
	}
}
